import React from 'react';
export var LabelsAlongYAxis = React.forwardRef(function (props, ref) {
    var totalGuides = props.totalGuides, fontSize = props.fontSize, pointIncrements = props.pointIncrements, height = props.height, width = props.width, totalPadding = props.totalPadding, linearEndPadding = props.linearEndPadding, linearStartPadding = props.linearStartPadding, showDecimalIncrements = props.showDecimalIncrements;
    var yLabels = Array.from(Array(totalGuides + 1)).map(function (_, i) { return i * pointIncrements; });
    return (React.createElement("g", { ref: ref, id: "y-labels", fill: "var(--text)", fillOpacity: 0.6, fontSize: fontSize * 0.8, fontFamily: "var(--heading)" }, yLabels.map(function (label, index) {
        var ratio = index / totalGuides;
        var chartHeight = height - totalPadding;
        chartHeight - chartHeight * ratio + linearEndPadding + fontSize / 2;
        var y = linearEndPadding + chartHeight - chartHeight * ratio;
        var visible = true;
        if (!showDecimalIncrements) {
            visible = !label.toString().includes('.');
        }
        return (React.createElement(React.Fragment, { key: label },
            React.createElement("text", { x: fontSize, y: y, style: { visibility: visible ? 'visible' : 'hidden' } }, label),
            React.createElement("polyline", { points: "".concat(linearStartPadding, ",").concat(y, " ").concat(width - linearEndPadding, ",").concat(y), stroke: "var(--text)", strokeOpacity: visible ? 0.3 : 0.15, strokeDasharray: "2 2" })));
    })));
});
export function LabelsAlongXAxis(props) {
    var fontSize = props.fontSize, width = props.width, height = props.height, linearStartPadding = props.linearStartPadding, labels = props.labels, linearEndPadding = props.linearEndPadding;
    var y = height - linearStartPadding + fontSize * 1.8;
    var startLabelX = linearStartPadding;
    var endLabelX = width - linearEndPadding;
    return (React.createElement("g", { id: "x-labels", fill: "var(--text)", fillOpacity: 0.6, fontSize: fontSize * 0.8, fontFamily: "var(--heading)" },
        React.createElement("text", { x: startLabelX, y: y }, labels[0]),
        React.createElement("text", { x: endLabelX, y: y, textAnchor: "end" }, labels[1])));
}
